// assets/cart-ch.js












// Cart promo compare pricing
(() => {
  if (window.__CH_CART_PROMO_PRICING_BOUND__) return;
  window.__CH_CART_PROMO_PRICING_BOUND__ = true;

  window.CH = window.CH || {};

  const resultCache = new Map();

  const getCurrency = () =>
    window.Shopify?.currency?.active || window.Shopify?.currency || "USD";

  const money = (cents) => {
    const n = (parseInt(cents, 10) || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: getCurrency(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    } catch {
      return n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  };

  function getRows() {
    return Array.from(document.querySelectorAll(".cartrow[data-line-key]"));
  }

  function ensureUnitMarkup(row) {
    if (!row) return null;

    const unitEl = row.querySelector("[data-unit]");
    if (!unitEl) return null;

    let normalEl = unitEl.querySelector("[data-cart-normal-unit]");
    let currentEl = unitEl.querySelector("[data-cart-current-unit]");

    if (!currentEl) {
      const unitCents = parseInt(row.getAttribute("data-unit-cents") || "0", 10) || 0;
      const existingText = String(unitEl.textContent || "").trim();

      unitEl.textContent = "";

      normalEl = document.createElement("span");
      normalEl.className = "cartrow__normal-unit";
      normalEl.setAttribute("data-cart-normal-unit", "");
      normalEl.hidden = true;

      currentEl = document.createElement("span");
      currentEl.className = "cartrow__current-unit";
      currentEl.setAttribute("data-cart-current-unit", "");
      currentEl.textContent = existingText || `${money(unitCents)}/ea`;

      unitEl.appendChild(normalEl);
      unitEl.appendChild(currentEl);
    }

    if (!normalEl) {
      normalEl = document.createElement("span");
      normalEl.className = "cartrow__normal-unit";
      normalEl.setAttribute("data-cart-normal-unit", "");
      normalEl.hidden = true;
      unitEl.insertBefore(normalEl, currentEl);
    }

    return {
      unitEl,
      normalEl,
      currentEl,
    };
  }

  function resetPromoPrice(row, unitCents) {
    const parts = ensureUnitMarkup(row);
    if (!parts) return;

    const cents = parseInt(unitCents, 10) || 0;

    row.setAttribute("data-unit-cents", String(cents));

    parts.unitEl.classList.remove("is-cart-promo-price");
    parts.normalEl.textContent = "";
    parts.normalEl.hidden = true;
    parts.currentEl.textContent = `${money(cents)}/ea`;
  }

  window.CH.updateCartUnitPrice = function updateCartUnitPrice(row, unitCents) {
    resetPromoPrice(row, unitCents);

    if (row) {
      delete row.dataset.cartPromoLoadedKey;
    }

    window.CH.initCartPromoPricing?.({ force: true });
  };

  async function fetchPromoForRow(row) {
    const variantId = String(row.getAttribute("data-variant-id") || "").trim();
    const servedCents = Math.round(Number(row.getAttribute("data-unit-cents") || "0"));
    const normalLevel = String(row.getAttribute("data-normal-price-level") || "").trim();

    if (!variantId || !servedCents || !normalLevel) return null;

    const endpoint =
      `/apps/staff-pricing/promo-pricing` +
      `?variant_id=${encodeURIComponent(variantId)}` +
      `&served_cents=${encodeURIComponent(String(servedCents))}` +
      `&normal_level=${encodeURIComponent(normalLevel)}`;

    if (resultCache.has(endpoint)) {
      return resultCache.get(endpoint);
    }

    const promise = fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        Accept: "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) return null;
        return res.json().catch(() => null);
      })
      .catch(() => null);

    resultCache.set(endpoint, promise);

    return promise;
  }

  function applyPromoToRow(row, data) {
    if (!row || !data?.ok || !data?.showPromo || !data?.normalDisplayPrice) return;

    const parts = ensureUnitMarkup(row);
    if (!parts) return;

    parts.normalEl.textContent = `${data.normalDisplayPrice}/ea`;
    parts.normalEl.hidden = false;

    parts.currentEl.textContent = `${data.servedDisplayPrice || money(row.getAttribute("data-unit-cents"))}/ea`;

    parts.unitEl.classList.add("is-cart-promo-price");
  }

  async function loadRow(row, { force = false } = {}) {
    if (!row) return;

    const variantId = String(row.getAttribute("data-variant-id") || "").trim();
    const servedCents = Math.round(Number(row.getAttribute("data-unit-cents") || "0"));
    const normalLevel = String(row.getAttribute("data-normal-price-level") || "").trim();

    if (!variantId || !servedCents || !normalLevel) return;

    const loadedKey = `${variantId}:${servedCents}:${normalLevel}`;

    if (!force && row.dataset.cartPromoLoadedKey === loadedKey) {
      return;
    }

    row.dataset.cartPromoLoadedKey = loadedKey;

    const data = await fetchPromoForRow(row);
    applyPromoToRow(row, data);
  }

  window.CH.initCartPromoPricing = function initCartPromoPricing(options = {}) {
    const force = !!options.force;
    const rows = getRows();

    rows.forEach((row) => {
      ensureUnitMarkup(row);
      loadRow(row, { force });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      window.CH.initCartPromoPricing?.({ force: true });
    }, { once: true });
  } else {
    window.CH.initCartPromoPricing?.({ force: true });
  }
})();















// Cart – Refresh stale Shopify Catalog/B2B pricing on cart page load
(() => {
  const ROOT = window.Shopify?.routes?.root || "/";
  const cartRoot = document.getElementById("cart-ch");
  if (!cartRoot) return;

  const rowsWrap = document.getElementById("cart-lines");
  const checkoutLink = document.querySelector(".cartbar__checkout");

  const getCurrency = () =>
    window.Shopify?.currency?.active || window.Shopify?.currency || "USD";

  const money = (cents) => {
    const n = (parseInt(cents, 10) || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: getCurrency(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    } catch {
      return n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  };

  const fmtInt = (n) => {
    try {
      return Number(n || 0).toLocaleString(undefined);
    } catch {
      return String(n || 0);
    }
  };

  function getRows() {
    return Array.from(document.querySelectorAll(".cartrow[data-line-key]"));
  }

  function buildNoOpUpdatesFromRows() {
    const updates = {};

    getRows().forEach((row) => {
      const key = row.getAttribute("data-line-key");
      const qtyInput = row.querySelector(".cartrow__qty-input");
      const qty = Math.max(0, parseInt(qtyInput?.value || row.dataset.quantity || "0", 10) || 0);

      if (key && qty > 0) {
        updates[key] = qty;
      }
    });

    return updates;
  }

  async function refreshCartPricing() {
    const updates = buildNoOpUpdatesFromRows();

    if (!Object.keys(updates).length) {
      return { cart: null, changed: false };
    }

    cartRoot.classList.add("is-refreshing-prices");
    cartRoot.setAttribute("aria-busy", "true");

    try {
      const res = await fetch(`${ROOT}cart/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      if (!res.ok) {
        throw new Error("Cart price refresh failed.");
      }

      const cart = await res.json();
      const changed = applyRefreshedCart(cart);

      return { cart, changed };
    } finally {
      cartRoot.classList.remove("is-refreshing-prices");
      cartRoot.removeAttribute("aria-busy");
    }
  }

  function applyRefreshedCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    let changed = false;

    const rows = getRows();
    const rowsByOldKey = new Map();

    rows.forEach((row) => {
      const key = row.getAttribute("data-line-key");
      if (key) rowsByOldKey.set(key, row);
    });

    cart.items.forEach((item, index) => {
      const row = rowsByOldKey.get(item.key) || rows[index];
      if (!row) return;

      const oldUnit = parseInt(row.getAttribute("data-unit-cents") || "0", 10) || 0;
      const oldLine = parseInt(row.getAttribute("data-line-cents") || "0", 10) || 0;

      const newUnit = Number(item.final_price || 0);
      const newLine = Number(item.final_line_price || 0);

      if (oldUnit !== newUnit || oldLine !== newLine) {
        changed = true;
      }

      row.setAttribute("data-line-key", item.key);
      row.setAttribute("data-unit-cents", String(newUnit));
      row.setAttribute("data-line-cents", String(newLine));
      row.setAttribute("data-quantity", String(item.quantity || 0));

      const qtyInput = row.querySelector(".cartrow__qty-input");
      if (qtyInput) qtyInput.value = String(item.quantity || 0);

      if (window.CH?.updateCartUnitPrice) {
  window.CH.updateCartUnitPrice(row, newUnit);
} else {
  const unitEl = row.querySelector("[data-unit]");
  if (unitEl) unitEl.textContent = `${money(newUnit)}/ea`;
}

      const subEl = row.querySelector("[data-sub]");
      if (subEl) subEl.textContent = money(newLine);
    });

    const unitsEl = document.getElementById("cart-units");
    const uniqueEl = document.getElementById("cart-unique");
    const totalEl = document.getElementById("cart-total");

    if (unitsEl) unitsEl.textContent = fmtInt(cart.item_count || 0);
    if (uniqueEl) uniqueEl.textContent = fmtInt((cart.items || []).length);
    if (totalEl) totalEl.textContent = money(cart.total_price || 0);

    window.CH?.refreshCartCount?.();

    if (changed) {
      showCartPriceRefreshNotice();
    }



    window.CH?.initCartPromoPricing?.({ force: true });

    return changed;
  }

  function showCartPriceRefreshNotice() {
    if (document.querySelector(".cart-ch__price-refresh-notice")) return;

    const bar = document.querySelector(".cartbar");
    if (!bar) return;

    const notice = document.createElement("div");
    notice.className = "cart-ch__price-refresh-notice";
    notice.textContent = "Cart pricing has been refreshed with current catalog pricing.";

    bar.insertAdjacentElement("afterend", notice);

    setTimeout(() => {
      notice.remove();
    }, 5000);
  }




// ------------------------------
// Stale cart refresh triggers
// ------------------------------
const ONE_HOUR_MS = 60 * 60 * 1000;
const TAB_AWAY_REFRESH_AFTER_MS = 10 * 60 * 1000;
const MIN_REFRESH_GAP_MS = 30 * 1000;

let lastUserActivityAt = Date.now();
let tabHiddenAt = document.hidden ? Date.now() : 0;
let lastRefreshRequestAt = 0;
let refreshInFlight = null;

function requestPricingRefresh(reason, { force = false } = {}) {
  const now = Date.now();

  if (refreshInFlight) {
    return refreshInFlight;
  }

  if (!force && now - lastRefreshRequestAt < MIN_REFRESH_GAP_MS) {
    return Promise.resolve({ skipped: true, reason: "too-soon" });
  }

  lastRefreshRequestAt = now;

  refreshInFlight = refreshCartPricing()
    .catch((err) => {
      console.warn("Cart pricing refresh failed:", reason, err);
    })
    .finally(() => {
      refreshInFlight = null;
    });

  return refreshInFlight;
}

function handleUserActivity() {
  const now = Date.now();
  const idleFor = now - lastUserActivityAt;

  lastUserActivityAt = now;

 if (idleFor >= ONE_HOUR_MS) {
  requestPricingRefresh("user-returned-after-idle", { force: true });
}
}

function handleVisibilityReturn() {
  if (document.hidden) {
    tabHiddenAt = Date.now();
    return;
  }

  const now = Date.now();
  const awayFor = tabHiddenAt ? now - tabHiddenAt : 0;

  tabHiddenAt = 0;
  lastUserActivityAt = now;

  if (awayFor >= TAB_AWAY_REFRESH_AFTER_MS) {
    requestPricingRefresh("tab-returned-after-away", { force: true });
  }
}

// Refresh once when the cart page loads.
if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    () => {
      requestPricingRefresh("cart-page-load", { force: true });
    },
    { once: true }
  );
} else {
  requestPricingRefresh("cart-page-load", { force: true });
}

// If customer leaves cart tab open and comes back later.
document.addEventListener("visibilitychange", handleVisibilityReturn);
window.addEventListener("focus", handleVisibilityReturn);

// If customer stays on the cart tab but goes idle for 5 hours,
// refresh on the next real interaction.
["mousemove", "pointerdown", "keydown", "touchstart", "scroll"].forEach((eventName) => {
  document.addEventListener(eventName, handleUserActivity, { passive: true });
});

// Also refresh right before checkout, in case customer leaves cart page open.
checkoutLink?.addEventListener("click", async (event) => {
  event.preventDefault();

  const href = checkoutLink.getAttribute("href") || "/checkout";

  try {
    checkoutLink.setAttribute("aria-disabled", "true");
    checkoutLink.textContent = "Updating Pricing…";

    await requestPricingRefresh("checkout-click", { force: true });
  } catch (err) {
    console.warn(err);
  } finally {
    window.location.href = href;
  }
});








})();






// Cart – Classic Home (desktop)
// CART-CH BASELINE + note-key fix + forced comma money formatting + Add/Remove Note toggle
(() => {
 const $  = (s, r=document) => r.querySelector(s);
 const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
 const ROOT = (window.Shopify?.routes?.root || '/');
 const root = $('#cart-ch');
 if (!root) return;
 const linesWrap = $('#cart-lines', root);
 const totalEl   = $('#cart-total', root);
 const unitsEl   = $('#cart-units', root);
 const uniqueEl  = $('#cart-unique', root);

 // --- Currency with grouping (commas) enforced ---
 const getCurrency = () => (window.Shopify?.currency?.active || window.Shopify?.currency || 'USD');
 const money = (cents) => {
   const n = (parseInt(cents, 10) || 0) / 100;
   try {
     return new Intl.NumberFormat(undefined, {
       style: 'currency',
       currency: getCurrency(),
       minimumFractionDigits: 2,
       maximumFractionDigits: 2
     }).format(n);
   } catch {
     // Fallback still keeps grouping
     return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'decimal' });
   }
 };
 const fmtInt = (n) => {
   try { return Number(n || 0).toLocaleString(undefined); }
   catch { return String(n || 0); }
 };
 // --- API helpers ---
 const changeLine = async ({ id, quantity, properties }) => {
   const body = { id, quantity };
   if (properties) body.properties = properties; // replaces properties
   const res = await fetch(`${ROOT}cart/change.js`, {
     method: 'POST',
     headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
     body: JSON.stringify(body),
     credentials: 'same-origin'
   });
   if (!res.ok) throw new Error('Change failed');
   return res.json(); // full cart
 };





 const mapItemsByKey = (cart) => {
   const map = new Map();
   (cart.items || []).forEach(it => map.set(it.key, it));
   return map;
 };
 // Handle key change after note/property updates
 const getRowVariantId = (row) => {
   const v = row.getAttribute('data-variant-id')
     || row.dataset.variantId
     || row.querySelector('[data-variant-id]')?.getAttribute('data-variant-id')
     || row.querySelector('[data-variant]')?.getAttribute('data-variant');
   return v ? String(v) : null;
 };
 const propsEqual = (a, b) => {
   const av = (a && a['Side Mark']) ?? '';
   const bv = (b && b['Side Mark']) ?? '';
   return String(av) === String(bv);
 };
 const findUpdatedItemForRow = (cart, { oldKey, row, desiredQty, newProps }) => {
   const byKey = mapItemsByKey(cart);
   const exact = byKey.get(oldKey);
   if (exact) return exact;
   const vid = getRowVariantId(row);
   if (vid) {
     const candidates = (cart.items || []).filter(it => String(it.id) === String(vid));
     let match = candidates.find(it => propsEqual(it.properties, newProps));
     if (!match && typeof desiredQty === 'number') match = candidates.find(it => it.quantity === desiredQty);
     if (match) return match;
   }
   const title = row.querySelector('.cartrow__title, .cgrid__title')?.textContent?.trim();
   if (title) {
     const byTitle = (cart.items || []).filter(it => (it.product_title || it.title || '').trim() === title);
     let match = byTitle.find(it => propsEqual(it.properties, newProps));
     if (!match && typeof desiredQty === 'number') match = byTitle.find(it => it.quantity === desiredQty);
     if (match) return match;
   }
   return null;
 };
 // --- UI sync ---
 const syncTotals = (cart) => {
   if (!cart) return;
   unitsEl  && (unitsEl.textContent  = fmtInt(cart.item_count || 0));          // Total units (with commas)
   uniqueEl && (uniqueEl.textContent = fmtInt((cart.items || []).length));     // Total products
   totalEl  && (totalEl.textContent  = money(cart.total_price || 0));          // Total wholesale (with commas)
   window.CH?.refreshCartCount?.();                                            // header badge
 };
 const syncRow = (row, item) => {
   if (!row || !item) return;
   row.setAttribute('data-line-key', item.key);
   row.setAttribute('data-unit-cents', String(item.final_price || 0));
row.setAttribute('data-line-cents', String(item.final_line_price || 0));
row.setAttribute('data-quantity', String(item.quantity || 0));
   const qtyInput = $('.cartrow__qty-input', row);
   if (qtyInput) qtyInput.value = item.quantity;





if (typeof item.final_price === 'number') {
  if (window.CH?.updateCartUnitPrice) {
    window.CH.updateCartUnitPrice(row, item.final_price);
  } else {
    const unitEl = $('[data-unit]', row);
    if (unitEl) unitEl.textContent = `${money(item.final_price)}/ea`;
  }
}


   const subEl = $('[data-sub]', row);
   if (subEl && typeof item.final_line_price === 'number') subEl.textContent = money(item.final_line_price);
 };
 const removeRow = (row) => { row.remove(); };
 const setRowBusy = (row, yes) => {
   row.dataset.busy = yes ? '1' : '0';
   const input = row.querySelector('.cartrow__qty-input');
   if (input) input.disabled = !!yes;
   row.querySelectorAll('[data-minus],[data-plus],[data-remove]').forEach(btn => {
     btn.disabled = !!yes;
   });
 };
 function bindRow(row) {
   const keyAttr  = () => row.getAttribute('data-line-key');
   const qtyWrap  = $('[data-qty]', row);
   const minus    = $('[data-minus]', qtyWrap);
   const plus     = $('[data-plus]',  qtyWrap);
   const input    = $('.cartrow__qty-input', qtyWrap);
   const remove   = $('[data-remove]', row);
   const noteBtn  = $('.cartrow__note-toggle', row);
   const noteWrap = $('.cartrow__note-wrap', row);
   const noteInp  = $('.cartrow__note', row);
   const getQty = () => Math.max(0, parseInt(input?.value, 10) || 0);
   const doChange = async ({ nextQty, props }) => {
     if (!keyAttr()) return;
     if (row.dataset.busy === '1') return;
     setRowBusy(row, true);
     try {
       const cart = await changeLine({ id: keyAttr(), quantity: nextQty, properties: props });
       let item = mapItemsByKey(cart).get(keyAttr());
       if (!item) {
         item = findUpdatedItemForRow(cart, {
           oldKey: keyAttr(),
           row,
           desiredQty: nextQty,
           newProps: props
         });
         if (item) row.setAttribute('data-line-key', item.key);
       }
       if (!item || nextQty === 0 || item.quantity === 0) {
         removeRow(row);
       } else {
         syncRow(row, item);            // per-row unit & subtotal (with commas)
       }
       syncTotals(cart);                // totals (with commas)
     } catch (e) {
       console.error(e);
       alert('Update failed. Please try again.');
     } finally {
       setRowBusy(row, false);
     }
   };
   // Qty controls
   minus?.addEventListener('click', () => {
     const q = getQty();
     const next = Math.max(0, q - 1);
     doChange({ nextQty: next });
   });
   plus?.addEventListener('click', () => {
     const q = getQty();
     doChange({ nextQty: q + 1 });
   });
   input?.addEventListener('change', () => {
     doChange({ nextQty: getQty() });
   });
   remove?.addEventListener('click', () => {
     doChange({ nextQty: 0 });
   });
   // --- Notes (Side Mark) — toggle label + reset-on-remove ---
   // Labels (customizable via data-add-label / data-remove-label on the button)
   const addLabel    = noteBtn?.getAttribute('data-add-label')    || '+ Add Note';
   const removeLabel = noteBtn?.getAttribute('data-remove-label') || '- Remove Note';
   const setToggleLabel = (open) => { if (noteBtn) noteBtn.textContent = open ? removeLabel : addLabel; };
   // Initial label based on existing value/visibility
   if (noteBtn) {
     const hasVal = !!(noteInp && noteInp.value && noteInp.value.trim().length);
     const isOpen = noteWrap && !noteWrap.hasAttribute('hidden');
     setToggleLabel(hasVal || isOpen);
   }
   // Guard to avoid double-save when we click "Remove Note" (which blurs the input)
   let skipNextBlur = false;
   // Toggle click: open -> show & label = remove; open state click => clear + collapse + remove property
   noteBtn?.addEventListener('click', () => {
     const opening = noteWrap?.hasAttribute('hidden');
     if (opening) {
       // Open editor
       noteWrap.removeAttribute('hidden');
       setToggleLabel(true);
       noteInp?.focus();
     } else {
       // Remove/reset
       if (noteInp) noteInp.value = '';
       setToggleLabel(false);
       // Prevent blur handler from firing a second request
       skipNextBlur = true;
       noteInp?.blur();
       noteWrap.setAttribute('hidden', '');
       // Remove property now
       doChange({ nextQty: getQty(), props: { 'Side Mark': null } });
     }
   });
   // Save on blur / Enter; empty = remove property + label back to "+ Add Note"
   const persistNote = () => {
     if (skipNextBlur) { skipNextBlur = false; return; }
     const val = (noteInp?.value || '').trim();
     if (val === '') {
       setToggleLabel(false);
       doChange({ nextQty: getQty(), props: { 'Side Mark': null } });
     } else {
       setToggleLabel(true);
       doChange({ nextQty: getQty(), props: { 'Side Mark': val } });
     }
   };
   noteInp?.addEventListener('blur', persistNote);
   noteInp?.addEventListener('keydown', (e) => {
     if (e.key === 'Enter') { e.preventDefault(); noteInp.blur(); }
   });
 }
 // Bind existing rows
 $$('.cartrow', linesWrap).forEach(bindRow);



})();













// ===== Cart: “Add Products” modal & bulk SKU add — FINAL with theme SKU resolver + CSV =====
(() => {
  const ROOT = (window.Shopify?.routes?.root || '/');
  const byId = (id) => document.getElementById(id);
  const $ = (s, r=document) => r.querySelector(s);

  const trigger = byId('cart-add-products');   // “+ Add Products” button
  const modal   = byId('cart-addmodal');
  if (!trigger || !modal) return;

  const ta              = byId('cart-addmodal-input');
  const addBtn          = byId('cart-addmodal-add');
  const csvTemplateBtn  = byId('cart-addmodal-template');
  const csvUploadInput  = byId('cart-addmodal-csv');

  // ---------- Open / Close ----------
  const open = () => {
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    setTimeout(() => ta?.focus(), 0);
  };
  const close = () => {
    modal.setAttribute('hidden','');
    modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (ta) ta.value = '';
    if (csvUploadInput) csvUploadInput.value = '';
  };
  trigger.addEventListener('click', (e) => { e.preventDefault(); open(); });
  modal.addEventListener('click', (e) => { if (e.target.hasAttribute('data-close')) close(); });
  $('.cart-addmodal__close', modal)?.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (!modal.hasAttribute('hidden') && e.key === 'Escape') close(); });

  // ---------- Textarea Helpers (existing behavior) ----------

  // Supports comma-separated AND/OR one-per-line; preserves trailing zeros
  const parseSkus = (raw) => Array.from(new Set(
    String(raw || '')
      .replace(/\r\n/g, '\n')          // normalize newlines
      .split(/[,\n]+/g)                // split on commas OR new lines
      .map(s => s.replace(/[“”"']+/g, '').trim())
      .filter(Boolean)
  ));

  const looksLikeVariantId = (s) => /^\d{12,20}$/.test(s);
  async function safeFetchJSON(url, timeoutMs = 8000) {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
      const res = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: ctrl.signal
      });
      if (!res.ok) return null;
      return await res.json().catch(() => null);
    } catch {
      return null;
    } finally {
      clearTimeout(t);
    }
  }
  // A) Theme endpoint — exact + reliable



async function resolveViaThemeSKU(sku) {
  const data = await safeFetchJSON(
    `${ROOT}search?view=sku-resolve&q=${encodeURIComponent(sku)}`,
    8000
  );
  const id = data?.ok && data?.variant_id ? Number(data.variant_id) : 0;
  return id ? String(id) : null;
}

async function resolveViaSuggestProductJs(sku) {
  const q = String(sku || '').trim();
  if (!q) return null;

  const suggestUrl =
    `${ROOT}search/suggest.json` +
    `?q=${encodeURIComponent(q)}` +
    `&resources[type]=product` +
    `&resources[limit]=10` +
    `&resources[options][unavailable_products]=show`;

  const suggest = await safeFetchJSON(suggestUrl, 8000);
  const products = Array.isArray(suggest?.resources?.results?.products)
    ? suggest.resources.results.products
    : [];

  for (const p of products) {
    const handle = String(p?.handle || '').trim();
    if (!handle) continue;

    const product = await safeFetchJSON(`${ROOT}products/${encodeURIComponent(handle)}.js`, 8000);
    const variants = Array.isArray(product?.variants) ? product.variants : [];

    const match = variants.find((v) =>
      String(v?.sku || '').trim().toLowerCase() === q.toLowerCase()
    );

    if (match?.id) return String(match.id);
  }

  return null;
}

async function resolveVariantIdBySKU(sku) {
  if (looksLikeVariantId(sku)) return String(sku);

  let id = await resolveViaThemeSKU(sku);
  if (id) return id;

  id = await resolveViaSuggestProductJs(sku);
  if (id) return id;

  return null;
}








  async function addItems(items) {
    const res = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.description || 'Add failed');
    }
    return res.json();
  }
  async function hardRefreshCartView() {
    window.CH?.refreshCartCount?.();
    try {
      const cart = await safeFetchJSON(`${ROOT}cart.js`);
      const $units  = document.getElementById('cart-units');
      const $unique = document.getElementById('cart-unique');
      const $total  = document.getElementById('cart-total');
      if ($units)  $units.textContent  = String(cart?.item_count || 0);
      if ($unique) $unique.textContent = String((cart?.items || []).length || 0);
      if ($total && window.Shopify?.formatMoney) $total.textContent = Shopify.formatMoney(cart?.total_price || 0);
    } catch {}
    window.location.href = `${ROOT}cart`;
  }

  // ---------- CSV helpers (NEW) ----------

  // Download template with exactly the required headers
  function downloadCsvTemplate() {
    const csv = 'SKU,Quantity\n'; // header-only; user fills rows
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'classic-home-cart-template.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  // Parse CSV into [{ sku, qty }, ...]
  // Rules:
  //  - First row must have "SKU" and "Quantity" as first two headers (case-insensitive)
  //  - Any non-empty cell in columns C+ -> skip that row
  //  - Blank / invalid SKU or non-positive qty -> skip that row
  function parseCsvSkuQty(text) {
    const out = [];
    if (!text) return out;

    const lines = String(text)
      .replace(/\r\n/g, '\n')
      .split('\n')
      .map(l => l.trim());

    if (!lines.length) return out;

    const headerRaw = lines[0];
    if (!headerRaw) return out;

    const headerParts = headerRaw.split(',').map(h => h.trim().toLowerCase());
    const h0 = headerParts[0] || '';
    const h1 = headerParts[1] || '';

    if (h0 !== 'sku' || h1 !== 'quantity') {
      alert('CSV must have "SKU" and "Quantity" as the first two column headers.');
      return [];
    }

    for (let i = 1; i < lines.length; i += 1) {
      const line = lines[i];
      if (!line) continue;

      const cols = line.split(',');
      // Skip if anything is filled outside col A/B
      const hasExtra = cols.slice(2).some(v => v && v.trim() !== '');
      if (hasExtra) continue;

      const rawSku = (cols[0] || '').replace(/[“”"']+/g, '').trim();
      const rawQty = (cols[1] || '').trim();

      if (!rawSku) continue;

      const qty = parseInt(rawQty, 10);
      if (!Number.isFinite(qty) || qty <= 0) continue;

      out.push({ sku: rawSku, qty });
    }

    return out;
  }

  async function bulkAddFromEntries(entries, source) {
    const clean = (entries || []).filter(e => e && e.sku && e.qty && e.qty > 0);
    if (!clean.length) {
      if (source === 'csv') {
        alert('No valid rows were found in your CSV. Make sure data is only under "SKU" and "Quantity".');
      } else {
        alert('No valid SKUs were found. Please check the numbers and try again.');
      }
      return;
    }

    let prevLabel = '';
    if (addBtn) {
      prevLabel = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = (source === 'csv') ? 'Adding from CSV…' : 'Adding…';
    }

    const items = [];
    const missing = [];

    for (const { sku, qty } of clean) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const vid = await resolveVariantIdBySKU(sku);
        if (vid) {
          items.push({ id: Number(vid), quantity: qty });
        } else {
          missing.push(sku);
        }
      } catch (err) {
        console.warn('SKU resolve error:', sku, err);
        missing.push(sku);
      }
    }

    if (!items.length) {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = prevLabel;
      }
      const msg = source === 'csv'
        ? 'No valid SKUs from your CSV were found. Please check the SKUs and try again.'
        : 'No valid SKUs were found. Please check the numbers and try again.';
      alert(msg);
      return;
    }






try {
  await addItems(items);

 if (missing.length) {
  alert(
    'Some SKUs were skipped:\n\n' +
    missing.map((sku) => `${sku} isn't a valid SKU`).join('\n')
  );
}

  await hardRefreshCartView(); // navigates to /cart
} catch (err) {
  alert(err.message || 'Could not add items.');
  if (addBtn) {
    addBtn.disabled = false;
    addBtn.textContent = prevLabel;
  }
  return;
} finally {
  if (csvUploadInput) csvUploadInput.value = '';
}

if (addBtn) {
  addBtn.disabled = false;
  addBtn.textContent = prevLabel;
}

close();





  }

  // ---------- Textarea “Add” button (unchanged behavior) ----------
  addBtn?.addEventListener('click', async () => {
    const raw  = ta?.value || '';
    const skus = parseSkus(raw);
    if (!skus.length) { close(); return; }
    const entries = skus.map((sku) => ({ sku, qty: 1 }));
    await bulkAddFromEntries(entries, 'manual');
  });

  // ---------- CSV Template: Download (NEW) ----------
  csvTemplateBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    downloadCsvTemplate();
  });

  // ---------- CSV Upload (NEW) ----------
  csvUploadInput?.addEventListener('change', (e) => {
    const input = e.target;
    const file = input?.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (ev) => {
      const text = String(ev.target?.result || '');
      const entries = parseCsvSkuQty(text);
      if (!entries.length) {
        input.value = '';
        return;
      }
      await bulkAddFromEntries(entries, 'csv');
    };
    reader.readAsText(file);
  });
})();



























// ===== Cart bar sticky-to-header (top + visible portion of main) =====
(() => {
  const root = document.getElementById('cart-ch');
  if (!root) return;

  const docEl   = document.documentElement;
  const topRow  = document.querySelector('.ch-hdr__row.ch-hdr__top');
  const mainRow = document.querySelector('.ch-hdr__row.ch-hdr__main');
  const hdrWrap = document.querySelector('.ch-hdr, #ch-hdr, header'); // optional wrapper

  const px = (n) => `${Math.max(0, Math.round(n || 0))}px`;

  // Is the element render-visible?
  const isRenderable = (el) => {
    if (!el) return false;
    const cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0;
  };

  // Visible height of an element in the viewport (handles slide-out via transforms)
  const visibleHeight = (el) => {
    if (!isRenderable(el)) return 0;
    const r = el.getBoundingClientRect();
    const vis = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    return Math.max(0, vis);
  };

  // Bottom of the top row relative to the viewport (clamped ≥ 0)
  const topBottom = () => {
    if (!isRenderable(topRow)) return 0;
    const r = topRow.getBoundingClientRect();
    return Math.max(0, r.bottom);
  };

  // Calculate where the cart bar should start:
  // offset = bottom of top row + *visible* pixels of the main row.
  function computeOffset() {
    // If a single header wrapper exists and you prefer its total height, uncomment:
    // if (hdrWrap && isRenderable(hdrWrap)) return Math.max(0, hdrWrap.getBoundingClientRect().bottom);

    const bTop   = topBottom();
    const visMain = visibleHeight(mainRow);
    return bTop + visMain;
  }

  let raf = 0;
  const apply = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const off = computeOffset();
      const val = px(off);
      if (docEl.style.getPropertyValue('--cart-header-offset') !== val) {
        docEl.style.setProperty('--cart-header-offset', val);
      }
    });
  };

  // Recalculate on scroll/resize (no direction checks needed).
  window.addEventListener('scroll', apply, { passive: true });
  window.addEventListener('resize', apply, { passive: true });

  // React to header size/visibility changes.
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(apply);
    topRow  && ro.observe(topRow);
    mainRow && ro.observe(mainRow);
    hdrWrap && ro.observe(hdrWrap);
  }

  // In case visibility changes via class toggles (no size change), watch attributes.
  const mo = new MutationObserver(apply);
  [topRow, mainRow, hdrWrap].filter(Boolean).forEach(el => {
    mo.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
  });

  // Initial passes (handles reload & late layout shifts)
  apply();
  setTimeout(apply, 50);
  setTimeout(apply, 150);
  window.addEventListener('pageshow', apply);
  document.addEventListener('DOMContentLoaded', apply);
})();
